import RfiRecipients from './RfiRecipients.component';

export default RfiRecipients;
